( function( $ ){

    // let map_object;
    let center = {};

    // Setup the map
    function init_map(){

        $( '#top-5s-controls' ).loadingScreen( true );

        if( navigator.geolocation ){

            let lat = parseFloat( ThemeJS.Functions.get_query_parameter( 'lat' ) );
            let lng = parseFloat( ThemeJS.Functions.get_query_parameter( 'lng' ) );

            if( lat && lng ){
                center = {
                    lat,
                    lng
                };
                get_places();
                return;
            }

            navigator.geolocation.getCurrentPosition( ( position ) => {
                if( ThemeJS.Variables.testMode ){
                    center = {
                        lat: 43.580401,
                        lng: -79.664190
                    };
                }
                else{
                    center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                }
                get_places();
            }, ( error ) => {
                $( '.top-5s-location-block' ).slideDown();
                $( '#top-5s-controls' ).loadingScreen( false );
                console.log( error.message );
            });
            
        }
        else{

            $( '.top-5s-location-block' ).slideDown();
            $( '#top-5s-controls' ).loadingScreen( false );
        
        }

    }

    // Get places for map display
    let place_request_running = false;
    function get_places(){
        if( place_request_running ){
            return;
        }
        $( '#top-5s-controls' ).loadingScreen( true );
        place_request_running = true;
        ThemeJS.Functions.send_ajax_request({
            data: {
                center: center,
                nearby: $( '#top5-select-nearby' ).val(),
                distance: $( '#top5-select-distance' ).val(),
                place_type: $( '#top5-select-place-types' ).val(),
                page: page,
                action: 'top5-search'
            },
            success: (res) => {

                place_request_running = false;
                
                $( '#top-5s-controls' ).loadingScreen( false );
                $( '#top-5s-list' ).find( '.top-5-place:not(.top-5-blank)' ).remove();
                
                if( ! res.places.length ){
                    $( '.top-5s-empty' ).show();
                    update_pagination( 0 );
                    return;
                }

                let place_count = 1;
                res.places.forEach( ( place ) => {

                    $( '.top-5s-empty' ).hide();
                    
                    // Setup place div
                    let $blank  = $( '.top-5-blank' ).first().clone();
                    $blank.find( '.place-link' ).html( place.post_title );
                    $blank.find( '.place-link' ).attr( 'href', place.permalink );
                    $blank.find( '.address' ).html( place.address );
                    $blank.find( '.distance' ).html( place.distance + 'km' );
                    $blank.removeClass( 'top-5-blank' );

                    // Add Article Links
                    place.articles.forEach( ( article ) => {
                        $blank.append( '<a class="article-link" href="'+ article.post_name +'">'+ article.post_title +'</a>' );
                    });

                    $( '#top-5s-list' ).append( $blank );

                    place_count++;

                });

                update_pagination( res.pages );

            },
            error: (res) => {
                $( '.top-5s-empty' ).show();
                place_request_running = false;
            }
        });
    }

    let page = 1;
    function update_pagination( total_pages ){
        
        let $pagination     = $( '#top-5s-pagination' );
        if( total_pages <= 1 ){
            $pagination.hide();
            return;
        }

        $pagination.show();
        $pagination.find( '.current-page' ).html( page );
        $( '.total-pages' ).html( ' / ' + total_pages );

        if( page == 1 ){
            $( '.page-prev' ).hide();
        }
        else{
            $( '.page-prev' ).show();
        }

        if( total_pages == page ){
            $( '.page-next' ).hide();
        }
        else{
            $( '.page-next' ).show();
        }

        $( 'html, body' ).animate({
            scrollTop: $( '#top-5s-controls' ).offset().top
        }, 400);

    }

    // Listeners
    $( document ).ready( init_map );
    $( document ).on( 'change', '.select-container select', () => {
        page = 1;
        get_places(); 
    });
    $( '.page-prev' ).on( 'click', () => {
        page--;
        get_places();
    });
    $( '.page-next' ).on( 'click', () => {
        page++;
        get_places();
    });

})( jQuery );